/******************************************************************
 * Archivo : client/src/mutations/createRole.js
 * Proyecto: CB30
 * Módulo  : Administración de Roles
 *
 * Propósito:
 * Mutación para crear un nuevo Rol.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  mutation CreateRole(
    $code: String!
    $label: String!
    $description: String
    $permissions: [ID]
    $active: Boolean!
  ) {

    createRole(
      code: $code
      label: $label
      description: $description
      permissions: $permissions
      active: $active
    ) {

      id
      code
      label
      description
      active

    }

  }
`;


// WEBPACK FOOTER //
// ./src/mutations/createRole.js